// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '988e0385-7e54-4d72-baa0-58eeec3e951c',
      type: 'Container',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'ee26ad6a-07ff-4954-90c7-64176f2df271',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 20,
      y: -1,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_Tail',
      parent: '988e0385-7e54-4d72-baa0-58eeec3e951c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '67a00f38-c0d2-46a9-9a84-d9300cc9372f',
      type: 'Sprite',
      runtimeType: null,
      name: 'leftWing',
      className: '',
      x: -16,
      y: 0,
      anchor: {
        x: 0.8,
        y: 0.7
      },
      pivot: {
        x: 1,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_Wing_Back',
      parent: '988e0385-7e54-4d72-baa0-58eeec3e951c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '00337062-4312-4385-b2a0-1d47f8092a66',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.6
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_Body',
      parent: '988e0385-7e54-4d72-baa0-58eeec3e951c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '7f72f72e-5b5f-4ccb-88f2-cff49a989271',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 2,
      y: 9,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_Left_Foot',
      parent: '988e0385-7e54-4d72-baa0-58eeec3e951c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '6d9e61dd-7af3-42e7-b2e1-f4a0b91de7e1',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -14,
      y: 14,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_Right_Foot',
      parent: '988e0385-7e54-4d72-baa0-58eeec3e951c',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'ffab8739-3cc2-4dae-8088-726886bafaad',
      type: 'Sprite',
      runtimeType: null,
      name: 'rightWing',
      className: '',
      x: 11,
      y: -2,
      anchor: {
        x: 0.2,
        y: 0.7
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Bird_Wing_Front',
      parent: '988e0385-7e54-4d72-baa0-58eeec3e951c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '7a63f7a9-2c51-4563-9c21-15fe0f94248a',
      type: 'Sprite',
      runtimeType: null,
      name: 'musicNote2',
      className: '',
      x: 21,
      y: -45,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Note_1',
      parent: '988e0385-7e54-4d72-baa0-58eeec3e951c',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'aaf11ebe-de9a-4ded-b2d8-5d2de4ceb69a',
      type: 'Sprite',
      runtimeType: null,
      name: 'musicNote1',
      className: '',
      x: -9,
      y: -49,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Note_2',
      parent: '988e0385-7e54-4d72-baa0-58eeec3e951c',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class BirdTaskBubbleLayout {
  static raw = raw;
  root: Container;
  leftWing: Sprite;
  rightWing: Sprite;
  musicNote2: Sprite;
  musicNote1: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      leftWing: typeof raw['list'][3];
      rightWing: typeof raw['list'][7];
      musicNote2: typeof raw['list'][8];
      musicNote1: typeof raw['list'][9];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
